import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { fromEvent, map, merge, of, Subscription } from 'rxjs';
import { LoginService } from './api/auth/login.service';
import { ConfigService } from './api/core/config.service';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit, OnInit {
  title = 'notas';

  networkStatus: boolean = false;
  networkStatus$: Subscription = Subscription.EMPTY;

  constructor(
    private el: ElementRef,
    private configService: ConfigService,
    private authService: LoginService
  ) {}

  ngOnInit(): void {
    this.checkNetworkStatus();
    this.getModules();
  }

  getPermissions() {
    if (this.authService.isAuthenticated()) {
      this.authService.permissions().subscribe(
        data => {
          this.authService.setUserPermissions(data.permissions);
        },
        error => {
          console.log(error);
        }
      );
    } else {
      console.log('System Login');
    }
  }

  getModules() {
    // this.configService.modulesSystem().subscribe({
    //   next: (data: any) => {
    //     console.log(data);
    //   },
    // });
  }

  checkNetworkStatus() {
    this.networkStatus = navigator.onLine;
    this.networkStatus$ = merge(
      of(null),
      fromEvent(window, 'online'),
      fromEvent(window, 'offline')
    )
      .pipe(map(() => navigator.onLine))
      .subscribe(status => {
        // console.log('status', status);
        this.networkStatus = status;
      });
  }

  ngAfterViewInit() {
    (<any>$('#side-menu')).metisMenu();
    (<any>$('#sidebar-menu a')).each(function(index: any, element: any) {
      var pageUrl = window.location.href.split(/[?#]/)[0];
      if (element.href == pageUrl) {
        (<any>$(element)).addClass('mm-active');
        (<any>$(element)).parent().addClass('mm-active'); // add active to li of the current link
        (<any>$(element))
          .parent()
          .parent()
          .addClass('mm-show');
        (<any>$(element))
          .parent()
          .parent()
          .prev()
          .addClass('mm-active'); // add active class to an anchor
        (<any>$(element))
          .parent()
          .parent()
          .parent()
          .addClass('mm-active');
        (<any>$(element))
          .parent()
          .parent()
          .parent()
          .parent()
          .addClass('mm-show'); // add active to li of the current link
        (<any>$(element))
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .addClass('mm-active');
      }
    });

    (<any>$('.slimscroll-menu')).slimscroll({
      height: 'auto',
      position: 'right',
      size: '7px',
      color: '#9ea5ab',
      wheelStep: 5,
      touchScrollStep: 50
    });

    (<any>$('.slimscroll')).slimscroll({
      height: 'auto',
      position: 'right',
      size: '7px',
      color: '#9ea5ab',
      touchScrollStep: 50
    });

    (<any>$('.button-menu-mobile')).on('click', function(event: any) {
      event.preventDefault();
      (<any>$('body')).toggleClass('enlarged');
    });

    if ((<any>$(window)).width() < 1025) {
      (<any>$('body')).addClass('enlarged');
    } else {
      if ((<any>$('body')).data('keep-enlarged') != true)
        (<any>$('body')).removeClass('enlarged');
    }

    (<any>$('[data-toggle="tooltip"]')).tooltip();
    (<any>$('[data-toggle="popover"]')).popover();

    this.getPermissions();
  }

  loadParent(url: string) {
    (<any>$('#sidebar-menu a')).each(function(index: any, element: any) {
      (<any>$(element)).removeClass('mm-active');
      (<any>$(element)).parent().removeClass('mm-active'); // add active to li of the current link
      (<any>$(element))
        .parent()
        .parent()
        .removeClass('mm-show');
      (<any>$(element))
        .parent()
        .parent()
        .prev()
        .removeClass('mm-active'); // add active class to an anchor
      (<any>$(element))
        .parent()
        .parent()
        .parent()
        .removeClass('mm-active');
      (<any>$(element))
        .parent()
        .parent()
        .parent()
        .parent()
        .removeClass('mm-show'); // add active to li of the current link
      (<any>$(element))
        .parent()
        .parent()
        .parent()
        .parent()
        .parent()
        .removeClass('mm-active');
    });

    let menu_parent = <any>$('a[href^="/' + url + '"]');
    menu_parent.addClass('mm-active');
    menu_parent
      .parent()
      .parent()
      .addClass('mm-active');
  }

  childLoadMenu(url: string) {
    (<any>$('#sidebar-menu a')).each(function(index: any, element: any) {
      (<any>$(element)).removeClass('mm-active');
      (<any>$(element)).parent().removeClass('mm-active'); // add active to li of the current link
      (<any>$(element))
        .parent()
        .parent()
        .removeClass('mm-show');
      (<any>$(element))
        .parent()
        .parent()
        .prev()
        .removeClass('mm-active'); // add active class to an anchor
      (<any>$(element))
        .parent()
        .parent()
        .parent()
        .removeClass('mm-active');
      (<any>$(element))
        .parent()
        .parent()
        .parent()
        .parent()
        .removeClass('mm-show'); // add active to li of the current link
      (<any>$(element))
        .parent()
        .parent()
        .parent()
        .parent()
        .parent()
        .removeClass('mm-active');
    });

    let menu_child = <any>$('a[href^="/' + url + '"]');
    menu_child.addClass('mm-active');
    menu_child.parent('li').addClass('active'); // add active to li of the current link
    menu_child
      .parent()
      .parent()
      .addClass('mm-show');
    menu_child
      .parent()
      .parent()
      .prev()
      .addClass('mm-active'); // add active class to an anchor
    menu_child
      .parent()
      .parent()
      .parent()
      .addClass('mm-active');
    menu_child
      .parent()
      .parent()
      .parent()
      .parent()
      .addClass('mm-show'); // add active to li of the current link
    menu_child
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .addClass('mm-active');
  }

  initMetisMenu() {
    (<any>$('#side-menu')).metisMenu();
    (<any>$('#sidebar-menu a')).each(function(index: any, element: any) {
      var pageUrl = window.location.href.split(/[?#]/)[0];
      if (element.href == pageUrl) {
        (<any>$(element)).addClass('mm-active');
        (<any>$(element)).parent().addClass('mm-active'); // add active to li of the current link
        (<any>$(element))
          .parent()
          .parent()
          .addClass('mm-show');
        (<any>$(element))
          .parent()
          .parent()
          .prev()
          .addClass('mm-active'); // add active class to an anchor
        (<any>$(element))
          .parent()
          .parent()
          .parent()
          .addClass('mm-active');
        (<any>$(element))
          .parent()
          .parent()
          .parent()
          .parent()
          .addClass('mm-show'); // add active to li of the current link
        (<any>$(element))
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .addClass('mm-active');
      }
    });
  }

  intSlimscrollmenu() {
    (<any>$('.slimscroll-menu')).slimscroll({
      height: 'auto',
      position: 'right',
      size: '7px',
      color: '#9ea5ab',
      wheelStep: 5,
      touchScrollStep: 50
    });
  }

  initSlimscroll() {
    (<any>$('.slimscroll')).slimscroll({
      height: 'auto',
      position: 'right',
      size: '7px',
      color: '#9ea5ab',
      touchScrollStep: 50
    });
  }

  initLeftMenuCollapse() {
    (<any>$('.button-menu-mobile')).on('click', function(event: any) {
      event.preventDefault();
      (<any>$('body')).toggleClass('enlarged');
    });
  }

  initEnlarge() {
    if ((<any>$(window)).width() < 1025) {
      (<any>$('body')).addClass('enlarged');
    } else {
      if ((<any>$('body')).data('keep-enlarged') != true)
        (<any>$('body')).removeClass('enlarged');
    }
  }

  initComponents() {
    (<any>$('[data-toggle="tooltip"]')).tooltip();
    (<any>$('[data-toggle="popover"]')).popover();
  }
}
